<template>
  <div class='h100-40 h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' 
              :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
      <e-columns :columns='shipColumns' textAlign='Center' clipMode='EllipsisWithTooltip'>
        <e-column field='name' minWidth='10' :headerText='$t("DeployManagement.nodeName")' textAlign='Center' width="80" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='typeCode' minWidth='10' :headerText='$t("DeployManagement.nodeType")' textAlign='Center' width="80" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='softwareVersion' minWidth='10' :headerText='$t("DeployManagement.productVersion")' textAlign='Center' width="100" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='displaySoftwareVersion' minWidth='10' :headerText='$t("DeployManagement.displaySoftWareVersion")' textAlign='Center' width="100" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='altitude' minWidth='10' :headerText='$t("Topo.altitude")' textAlign='Center' width="80" clipMode='EllipsisWithTooltip'></e-column>
     </e-columns>
    </ejs-grid>
  </div>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
  import bus from '../bus.js';
  import { EventBus } from '../../../plugins/eventBus';
  import socketInstance from '../../../plugins/stompSock';

  const { mapGetters, mapActions } = createNamespacedHelpers('trackConfig');
  export default {
    name: 'importResultTable',
    components: {
    },
    props: ['trackType'],
    data() {
      return {
        selectionOptions: { type: 'Single' },
        contextMenuItems: [
          { text: `${this.$t('Track.activationTask')}` },
          { text: `${this.$t('Track.suspendTask')}` },
          { text: `${this.$t('Track.taskDeletion')}` },
          { text: `${this.$t('Track.taskTracking')}` },
          { text: `${this.$t('Track.taskDetails')}` }
        ],
        currentNeInfo: '',
        data: [],
        primaryDatas: [],
        currentSelectDataId: '',
        shipColumns: [
          {
            field: 'ShippedDate',
            headerText: 'Shipped Date',
            format: 'yMd',
            textAlign: 'Right',
            width: 150,
            minWidth: 10
          },
          {
            field: 'ShipCountry',
            headerText: 'Ship Country',
            width: 150,
            minWidth: 10
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['currentNe']),
      ...mapGetters(['neVisionList']),
      ...mapGetters(['resourceIdList'])
    },
    provide: {
      grid: [Reorder, Resize, ExcelExport, ContextMenu]
    },
    methods: {
      formatDateTime(timeStamp) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },
      actDate(grids, data) {
      if(!!data.createTime&&data.createTime!=null){
        return this.formatDateTime(data.createTime);
      }else{
        return '';
      }
    },
    setData(row){
      console.log("==========",row);
       this.data = row;
    },
    mounted() {
      bus.$on('refreshTrackTable', () => {
        this.getTrackListData();
      });
    },
    beforeDestroy() {
      bus.$off('refreshTrackTable');
    }
    }
  };
</script>
